import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FormGroup, Label, Input as InputReact } from 'reactstrap'
import { Select, Input, message, Modal, Spin, Button as ButtonAntd, Popover, Tooltip } from 'antd'
import { ReactComponent as IconDelete } from "../../../assets/icon/icon-delete.svg"
import { ReactComponent as IconBarCode } from "../../../assets/icon/icon-barcode.svg"
import {
    batchShipDetails,
    createBatchShip,
    updateBatchShipBoxes,
    updateBatchShip,
    confirmBatchShip,
    retryCreateHWBox,
    genFbaBoxLabel,
} from '../../../services/api/apiBatchShip'
import getHistory from '../../../getHistory'
import { getLocalData } from '../../../services/StorageServices'
import { RedoOutlined } from '@ant-design/icons';
import _ from 'lodash'

const { Option } = Select

function BatchShipCreatePageContainer(props) {
    const batchShipId = props.match.params.id
    const [itemType, setItemType] = useState('package')
    const [status, setStatus] = useState('')
    const [error, setError] = useState('')
    const [searchValue, setSearchValue] = useState('')
    const [boxIndex, setBoxIndex] = useState(0)
    const [combineShip, setCombineShip] = useState({})
    const [boxNumber, setBoxNumber] = useState('')
    const [carrier, setCarrier] = useState('')
    const [trackingNumber, setTrackingNumber] = useState('')
    const [shippingFee, setShippingFee] = useState('')
    const [batchType, setBatchType] = useState('')
    const [shippingStatus, setShippingStatus] = useState('')
    const [size, setSize] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState([])
    const [listBoxes, setListBoxes] = useState([
        {
            label_url: "",
            weight: 0,
            length: size.length ? size[0] : 0,
            width: size.length ? size[1] : 0,
            height: size.length ? size[2] : 0,
            items: []
        }
    ])
    const [boxQuantity, setBoxQuantity] = useState(null)
    const [listBarcode, setListBarcode] = useState([])
    const [shipLabelLoadingId, setShipLabelLoadingId] = useState(null)
    const [shipLabelPreview, setShipLabelPreview] = useState('')
    // FAC-23949: các thùng đã gen label thành công (BE đang đồng bộ) -> ẩn nút gen, hiện trạng thái đang tạo.
    const [genSuccessBoxIds, setGenSuccessBoxIds] = useState([])

    const [boxCarrier, setBoxCarrier] = useState('')
    const userRoles = !!getLocalData('roles') && getLocalData('roles').length > 0 ? getLocalData('roles').map(i => i.name) : []
    const batchShipPermissions = !!getLocalData('user') && getLocalData('user').batch_ship
    const adminPermission = !!userRoles.length && userRoles.includes('fac_admin')
    const ffmPermission = !!userRoles.length && userRoles.includes('fac_ffm')

    const mapBoxes = (boxes = []) => boxes.map(i => ({
        ...i,
        items: i.items.map(j => j.item_code),
        rawItems: i.items, // giữ nguyên item object để đọc ship_to_object
        item: i.items[0] && i.items[0].item ? i.items[0].item : {}
    }))

    // silent = true: chỉ refetch dữ liệu (không bật spinner toàn trang, không toast lỗi) - dùng khi poll.
    // Trả về mảng boxes đã map để caller kiểm tra trạng thái label.
    const getBatchShipDetails = async (id, { silent = false } = {}) => {
        if (!silent) setLoading(true)
        try {
            const { data: Data } = await batchShipDetails(id)
            const { message: mess, success, data } = Data
            const { batch, boxes, errors } = { ...data }

            if (success) {
                setItemType(batch.item_type)
                setStatus(batch.status)
                setCarrier(batch.carrier)
                setTrackingNumber(batch.tracking_number)
                setShippingFee(batch.shipping_fee)
                setShippingStatus(batch.shipping_status)
                setBatchType(batch.batch_type)
                setBoxNumber(batch.id)
                setCombineShip(batch.combine_ship || {})
                setBoxCarrier(batch.box_carrier)
                setErrors(errors)
                if (boxes.length > 0) {
                    const mapped = mapBoxes(boxes)
                    setListBoxes([...mapped])
                    return mapped
                }
            } else if (!silent) {
                message.error(mess)
            }
        } catch (error) {
            if (!silent) message.error(error.message)
        } finally {
            if (!silent) setLoading(false)
        }
        return []
    }

    useEffect(() => {
        !!batchShipId && getBatchShipDetails(batchShipId)
    }, [])

    const handleSave = () => {
        setError('')
        if (!!batchShipId) {
            if (status === 'open') {
                handleUpdateBatchShipBox()
            }
            if (status === 'confirmed') {
                handleUpdateBatchShip()
            }

        } else {
            handleCreateBatchShip()
        }
    }

    const handleCreateBatchShip = async () => {
        const payload = {
            batch: {
                item_type: itemType,
                status: 'open',
            },
            boxes: listBoxes,
        }

        try {
            const { data: Data } = await createBatchShip(payload)
            const { success, message: mess } = Data
            if (success) {
                message.success('Lô ship đã được tạo!')
                const history = getHistory()
                history.push(`/batch-ship`)
            } else {
                message.error('Lô ship chưa được tạo!')
                setError(mess)
            }
        } catch (error) {
            message.error(error.message)
        }

    }

    const handleUpdateBatchShipBox = async () => {
        const payload = {
            batch: {
                item_type: itemType,
                status: status,
            },
            boxes: listBoxes
        }

        try {
            const { data: Data } = await updateBatchShipBoxes(batchShipId, payload)
            const { success, message: mess, } = Data
            if (success) {
                message.success('Thông tin lô ship đã được update!')
                // getBatchShipDetails(batchShipId)
                const history = getHistory()
                history.push(`/batch-ship`)
            } else {
                message.error('Thông tin lô ship chưa được update!')
                setError(mess)
            }
        } catch (error) {
            message.error(error.message)
        }

    }

    const handleUpdateBatchShip = async () => {
        const payload = {
            carrier: carrier,
            tracking_number: trackingNumber,
            shipping_fee: shippingFee,
        }

        try {
            const { data: Data } = await updateBatchShip(batchShipId, payload)
            const { success, message: mess, } = Data
            if (success) {
                message.success('Thông tin lô ship đã được update!')
                const history = getHistory()
                history.push(`/batch-ship`)
            } else {
                message.error(mess)
                setError(mess)
            }
        } catch (error) {
            message.error(error.message)
        }

    }

    const _handleChangeItemtype = (value) => {
        const listBoxesDefault = [
            {
                label_url: "",
                weight: 0,
                height: 0,
                length: 0,
                width: 0,
                items: []
            }
        ]
        setItemType(value)
        setListBoxes(listBoxesDefault)
        setError('')
    }

    const handleSearch = (index, value) => {
        setBoxIndex(index)
        setError('')
        if (value.includes(',') || value.includes(' ')) {
            setSearchValue('')
            const Value = [...new Set(value.replace(/ |#|'|_\d+/g, ",").split(',').map(i => i.trim()).filter(i => !!i && !listBoxes[index].items.includes(i) && i))]

            let listBoxesUpdated = []
            listBoxes.map((i, idx) => {
                if (idx === index && Value.length > 0) {
                    const merged = [...i.items, ...Value]
                    // FBA: mỗi dòng lô ship chỉ được add 1 thùng.
                    if (batchType === 'FBA' && merged.length > 1) {
                        message.warning('Lô ship FBA: mỗi dòng chỉ được thêm 1 thùng!')
                        return listBoxesUpdated.push({ ...i, ['items']: merged.slice(0, 1) })
                    }
                    return listBoxesUpdated.push({ ...i, ['items']: merged })
                }
                return listBoxesUpdated.push(i)
            })
            setListBoxes(listBoxesUpdated)
        } else {
            setSearchValue(value)
        }
    }

    const _handleAddNewBoxes = (isMoreBox = false) => {
        setError('')
        if(!isMoreBox) {
            setListBoxes([
                ...listBoxes,
                {
                    label_url: "",
                    weight: 0,
                    length: size.length ? size[0] : 0,
                    width: size.length ? size[1] : 0,
                    height: size.length ? size[2] : 0,
                    items: []
                }
            ])
        }else{
            let listBoxNew = []
            for(let i = 0; i < boxQuantity; i++){
                listBoxNew.push({
                    label_url: "",
                    weight: 0,
                    length: size.length ? size[0] : 0,
                    width: size.length ? size[1] : 0,
                    height: size.length ? size[2] : 0,
                    items: []
                })
            }
            setListBoxes([
                ...listBoxes,
                ...listBoxNew
            ])
            setBoxQuantity()
        }
    }

    const handleToggleModal = () => {
        setShowModal(!showModal)
    }

    const _handleConfirmBatchShip = async (id) => {
        try {
            const { data } = await confirmBatchShip(id)
            const { success, message: mess } = data
            if (success) {
                message.success('Trạng thái lô confirmed')
                handleToggleModal()
                if (adminPermission || (ffmPermission && !!batchShipPermissions)) {
                    getBatchShipDetails(id)
                } else {
                    const history = getHistory()
                    history.push(`/batch-ship`)
                }
            } else {
                message.error(mess)
            }
        } catch (error) {
            message.error(error.message)
        }
    }

    const _handleRemoveBoxes = (index) => {
        setError('')
        const listBoxesUpdated = listBoxes.filter((i, idx) => idx !== index)
        setListBoxes(listBoxesUpdated)
    }

    const _handleChangeBoxesState = (index, field, value) => {

        setError('')
        let listBoxesUpdated = []

        if (field === 'items') {
            setSearchValue('')
        }

        listBoxes.map((i, idx) => {
            if (idx === index) {
                if (field === 'items') {
                    const cleaned = [... new Set(value.filter(i => !!i && i).map(i => i.replace(/#|'|_\d+/g, "")))]
                    // FBA: mỗi dòng lô ship chỉ được add 1 thùng.
                    if (batchType === 'FBA' && cleaned.length > 1) {
                        message.warning('Lô ship FBA: mỗi dòng chỉ được thêm 1 thùng!')
                        return listBoxesUpdated.push({ ...i, ['items']: cleaned.slice(0, 1) })
                    }
                    return listBoxesUpdated.push({ ...i, ['items']: cleaned })
                }
                return listBoxesUpdated.push({ ...i, [field]: value })
            }

            return listBoxesUpdated.push(i)
        })

        setListBoxes(listBoxesUpdated)
    }

    const handleChangeShipDetails = (field, value) => {
        setError('')
        if (field === 'carrier') {
            setCarrier(value)
        }
        if (field === 'tracking_number') {
            setTrackingNumber(value)
        }
        if (field === 'shipping_fee') {
            setShippingFee(value)
        }

    }

    const handleChangeSize = (value) => {
        if (value) {
            const Value = value.split('x').map(i => parseFloat(i))
            setSize(Value)
            if (listBoxes.length) {

                const newListBoxes = listBoxes.map(i => ({
                    ...i,
                    length: i.length > 0 ? i.length : Value[0],
                    width: i.width > 0 ? i.width : Value[1],
                    height: i.height > 0 ? i.height : Value[2],
                }))
                setListBoxes(newListBoxes)
            }
        } else {
            setSize([])
        }
    }

    const handleRetryCreateHWBox = async (itemCodes) => {
        const payload = {
            item_codes: itemCodes
        }

        if(!!listBarcode.length) payload.ignoreBarcodes = listBarcode.map(b => Number(b))

        try {
            const { data: Data } = await retryCreateHWBox(batchShipId, payload)
            const { data, success } = Data
            if (success) {
                const {results = []} = data
                const {status: boxPartnerStatus, data: dataBoxPartner = {}} = !!results[0] ? results[0] : {}
                const {custom_error_message = '', error_message = ''} = _.get(dataBoxPartner, 'batchShipItem.item.box_partner_detail', {})

                if(boxPartnerStatus && boxPartnerStatus === 'done'){
                    message.success('Tạo thùng HW USPS thành công!')
                    getBatchShipDetails(batchShipId)
                }else{
                    message.error(custom_error_message || error_message || 'Tạo thùng HW USPS không thành công!')
                }
            } else {
                message.error('Tạo thùng HW USPS không thành công!')
            }
        } catch (error) {
            message.error(error.message)
        }
    }

    // FAC-23949: gen ship label FBA cho 1 thùng (BE tự chọn Type 1/Type 2 + service code theo state ship-to).
    // genFbaBoxLabel trả về thẳng body { success, message }. Dùng cho cả retry từng thùng.
    const handleGenShipLabel = async (box) => {
        const {item: boxItem} = box || {}
        const boxId = boxItem.id || ''
        if (!boxId) return
        setShipLabelLoadingId(box._id)
        try {
            const res = await genFbaBoxLabel(boxId, '1C')
            const { success, message: mess } = res || {}
            if (success) {
                // Gen thành công -> ẩn nút gen ngay, hiện trạng thái "đang tạo" (không chờ BE đồng bộ url).
                setGenSuccessBoxIds(prev => prev.includes(box._id) ? prev : [...prev, box._id])
                message.success('Yêu cầu gen ship label FBA được tạo thành công!')
                // Refetch 1 lần: nếu BE đã đồng bộ url thì hiện icon, chưa kịp thì ô giữ trạng thái "đang tạo".
                getBatchShipDetails(batchShipId, { silent: true })
            } else {
                message.error(mess || 'Gen ship label FBA không thành công!')
            }
        } catch (error) {
            // genFbaBoxLabel qua makeAuthRequest re-throw raw axios error, không bóc body -> lấy message BE từ response.
            message.error((error && error.response && error.response.data && error.response.data.message) || error.message)
        } finally {
            setShipLabelLoadingId(null)
        }
    }

    // FAC-23949: thùng đủ điều kiện gen ship label khi mọi item có đủ thông tin địa chỉ ship-to từ PLF.
    // ship_to_object nằm trong từng item của box; yêu cầu mọi item đều có đủ field địa chỉ.
    const isShipToAddressValid = (addr) => {
        if (!addr) return false
        return ['address_line_1', 'city', 'state', 'postal_code', 'country_code'].every(f => !!addr[f])
    }
    const isBoxShipToReady = (box) => {
        const {item: boxItem} = box || {}
        const {ship_to_object= {}} = boxItem || {}
        if (ship_to_object && isShipToAddressValid(ship_to_object)) return true
    }

    // Khoá sửa cân nặng/kích thước ở màn chi tiết lô ship:
    // - lô đã confirmed (giữ hành vi cũ), hoặc
    // - lô FBA: thùng FBA bắt buộc đã kết thúc cập nhật thông tin mới được tạo vào lô,
    //   nên mọi thùng trong lô FBA đều bị khoá cân nặng/kích thước.
    const isSizeWeightLocked = (!!batchShipId && status === 'confirmed') || batchType === 'FBA'

    const Title = !!batchShipId ? (status === 'open' ? `Sửa lô ship ${boxNumber}` :
        (shippingStatus === 'delivered' || (!adminPermission && !ffmPermission) ? `Chi tiết lô ship ${boxNumber}` : `Update thông tin lô ship ${boxNumber}`))
        : 'Thêm lô ship mới'

    const renderContent = (items) => {
        return (
            <div style={{maxWidth: "900px"}}>
                <span className='font-weight-bold text-danger'>Tạo thùng HW USPS không thành công, retry để tạo lại thùng.</span>
                <div className="barcode-input mt-2">
                    <span>Nhập barcode number sẽ bỏ qua khi tạo thùng</span>
                    <Select
                        mode={'tags'}
                        className='Boxes'
                        onChange={(value) => {
                            const items = value
                                .flatMap(v => {
                                    const str = String(v)

                                    return str.split(/[\s\t\n]+/)
                                })
                                .map(v => v.replace(/[^\d]/g, "")) 
                                .filter(Boolean)                 

                            const unique = [...new Set(items)]

                            setListBarcode(unique)
                        }}
                        dropdownRender={() => null}
                        style={{ width: '100%' }}
                        value={listBarcode}
                        open={false}
                        tokenSeparators={[' ', '\n', '\t']}
                        allowClear
                    />
                </div>
                <div className='d-flex align-items-center justify-content-end mt-2'>
                    <ButtonAntd
                        type="primary"
                        size="small"
                        onClick={() => handleRetryCreateHWBox(items)}
                    >
                        Retry
                    </ButtonAntd>

                </div>
            </div>
        )
    }

    return (
        <div className='BatchShipCreatePageContainer'>
            <div className='d-flex align-items-center justify-content-between'>
                <div className="ReturnPage mb-2">
                    <Link to={'/batch-ship'} className="txt-16">
                        <i className="fa fa-chevron-left mr-1" /> Danh sách lô ship
                    </Link>
                </div>

                {
                    !!batchShipId && boxCarrier === 'SB_FAST' && 
                    <div className="RedirectPage mb-2">
                        <Link to={`/combine-ship/${combineShip._id}`} className="txt-16">
                            <i className="fa fa-chevron-left mr-1" /> Đơn gộp ship {combineShip.id}
                        </Link>
                    </div>
                }
            </div>
            
            <div className='FileDetailPage'>
                <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                    <h1 className="PageTitle font-weight-bold mb-0">{!loading && Title}</h1>
                    <div className="RightTop">
                        {shippingStatus !== 'delivered' && !(!(status === '' || status === 'open') && (!adminPermission && !ffmPermission)) &&
                            <div className='Actions mb-2'>
                                <Link to={'/batch-ship'}>
                                    <button
                                        className='btn btn-secondary mx-1'
                                        style={{ background: '#C4C4C4' }}
                                    >
                                        Huỷ
                                    </button>
                                </Link>
                                <button
                                    className='btn btn-primary mx-1'
                                    style={{ background: '#4A80F7' }}
                                    onClick={handleSave}
                                >
                                    Lưu
                                </button>
                            </div>
                        }

                    </div>
                </div>
                <Spin spinning={loading} tip='Data Loading...'>
                    <div className="SectionInner card px-4 py-4 mt-3" style={{ minHeight: '730px' }}>
                        <h6 className='font-weight-bold txt-14'>CHỌN LOẠI LÔ SHIP</h6>
                        <div className='d-flex align-items-center'>
                            <FormGroup check className='mr-3 mb-0'>
                                <Label check className='txt-14'>
                                    <InputReact type="radio" name="package"
                                        checked={itemType === 'package'}
                                        disabled={!!batchShipId && itemType !== 'package'}
                                        onChange={({ target: { name } }) => _handleChangeItemtype(name)}
                                    /> Ship thùng
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check className='txt-14'>
                                    <InputReact type="radio" name="order"
                                        checked={itemType === 'order'}
                                        disabled={!!batchShipId && itemType !== 'order'}
                                        onChange={({ target: { name } }) => _handleChangeItemtype(name)}
                                    /> Ship đơn
                                </Label>
                            </FormGroup>
                        </div>
                        <div className=" mt-4 align-items-center">
                            <h6 className='font-weight-bold mb-2 txt-14'>THÔNG TIN LÔ SHIP {batchType === 'FBA' && 'FBA'}</h6>
                            <div className='align-items-start '>
                                <table>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>
                                                <div className="d-flex justify-content-between">
                                                    <span>{itemType === 'order' ? 'Đơn' : 'Box'} trong thùng ship</span>
                                                    <div className="d-flex align-items-baseline pr-4">
                                                        <label style={{ whiteSpace: 'nowrap', marginRight: '15px' }}>Số thùng</label>
                                                        <Input
                                                            value={boxQuantity || ''}
                                                            type='number'
                                                            placeholder='Nhập số thùng'
                                                            allowClear
                                                            onChange={(e) => setBoxQuantity(e.target.value)}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter") {
                                                                    e.preventDefault()
                                                                    _handleAddNewBoxes(true)
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </th>
                                            <th>Cân nặng</th>
                                            <th className=''>
                                                Kích thước
                                                { (status === 'open' || status==='') &&
                                                    <Select
                                                        className='float-right mr-2'
                                                        placeholder='Kích thước'
                                                        allowClear
                                                        onChange={handleChangeSize}
                                                    >
                                                        <Option value='10x10x10'>10x10x10</Option>
                                                        <Option value='21x16x7'>21x16x7</Option>
                                                        <Option value='21x16x11'>21x16x11</Option>
                                                        <Option value='31x26x21'>31x26x21</Option>
                                                        <Option value='51x42x42'>51x42x42</Option>
                                                        <Option value='61x42x42'>61x42x42</Option>
                                                        <Option value='84x42x42'>84x42x42</Option>
                                                    </Select>
                                                }
                                            </th>
                                            {!batchShipId && status === 'open' &&
                                                <th></th>
                                            }
                                            {!!batchShipId && status === 'confirmed' && batchType === 'FBA' && (
                                                <th className='text-center'>Ship label FBA</th>
                                            )}
                                            <th className='box-action'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!!listBoxes.length && listBoxes.map((i, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className='pr-3 align-items-center txt-14'>
                                                        Thùng {index + 1}
                                                    </td>
                                                    <td className='py-2 pr-4 align-items-center Box'>

                                                        <Select
                                                            mode={'tags'}
                                                            className='Boxes'
                                                            disabled={!!batchShipId && status === 'confirmed'}
                                                            onChange={(value) => _handleChangeBoxesState(index, 'items', value)}
                                                            style={{ minWidth: '600px' }}
                                                            value={[...i.items] || []}
                                                            onSearch={(value) => handleSearch(index, value)}
                                                            searchValue={boxIndex === index ? searchValue : ''}
                                                            virtual={false}
                                                            open={false}
                                                            allowClear
                                                        />
                                                    </td>
                                                    <td className='pr-4 align-items-center Weight'>
                                                        <Input
                                                            value={i.weight || ''}
                                                            type='number'
                                                            disabled={isSizeWeightLocked}
                                                            placeholder='weight'
                                                            allowClear
                                                            addonAfter="kg"
                                                            onChange={({ target: { value } }) => _handleChangeBoxesState(index, 'weight', value)}
                                                        />
                                                    </td>
                                                    <td className='pr-2 align-items-center Size'>
                                                        <div className='d-flex align-items-center'>
                                                            <Input
                                                                value={i.length || ''}
                                                                type='number'
                                                                className='Length'
                                                                disabled={isSizeWeightLocked}
                                                                placeholder='length'
                                                                allowClear
                                                                addonAfter="cm"
                                                                onChange={({ target: { value } }) => _handleChangeBoxesState(index, 'length', value)}
                                                            /> x
                                                            <Input
                                                                value={i.width || ''}
                                                                type='number'
                                                                className='Width'
                                                                disabled={isSizeWeightLocked}
                                                                placeholder='width'
                                                                allowClear
                                                                addonAfter="cm"
                                                                onChange={({ target: { value } }) => _handleChangeBoxesState(index, 'width', value)}
                                                            /> x
                                                            <Input
                                                                value={i.height || ''}
                                                                type='number'
                                                                className='Height'
                                                                disabled={isSizeWeightLocked}
                                                                placeholder='height'
                                                                allowClear
                                                                addonAfter="cm"
                                                                onChange={({ target: { value } }) => _handleChangeBoxesState(index, 'height', value)}
                                                            />
                                                        </div>
                                                    </td>
                                                    {
                                                        (!batchShipId || status === 'open') && listBoxes.length > 1 &&
                                                        <td>
                                                            <IconDelete className='cursor-pointer' onClick={() => _handleRemoveBoxes(index)} />
                                                        </td>
                                                    }
                                                    {!!batchShipId && status === 'confirmed' && batchType === 'FBA' && (
                                                        <td className='pr-2 align-middle text-center'>
                                                            {_.get(i, 'item.label_ship_details.url')
                                                                ? <Tooltip title='Xem ship label FBA'>
                                                                    <a className='cursor-pointer d-inline-flex align-items-center' onClick={() => setShipLabelPreview(_.get(i, 'item.label_ship_details.url'))}>
                                                                        <IconBarCode style={{ width: 24, height: 24 }} />
                                                                    </a>
                                                                </Tooltip>
                                                                : (!!_.get(i, 'item.label_ship_details') || genSuccessBoxIds.includes(i._id) || shipLabelLoadingId === i._id)
                                                                    ? <span className='d-flex align-items-center justify-content-center text-muted'>
                                                                        Đợi một chút và tải lại trang để đồng bộ.
                                                                    </span>
                                                                    : <span className='d-flex align-items-center justify-content-center'>
                                                                        <span className='text-muted mr-2'>Chưa có ship label FBA</span>
                                                                        {i._id && (
                                                                            <Tooltip title={!isBoxShipToReady(i) ? 'Thùng chưa đủ thông tin từ PLF' : ''}>
                                                                                <ButtonAntd
                                                                                    size='small'
                                                                                    type='primary'
                                                                                    disabled={!isBoxShipToReady(i)}
                                                                                    onClick={() => handleGenShipLabel(i)}
                                                                                >
                                                                                    Gen ship label FBA
                                                                                </ButtonAntd>
                                                                            </Tooltip>
                                                                        )}
                                                                    </span>
                                                            }
                                                        </td>
                                                    )}
                                                    {
                                                        i && i.item && i.item.box_partner_status &&
                                                        <td className='box-action'>
                                                            {
                                                                i.item.box_partner_status === 'done' ? <span style={{ color: 'green' }}>Tạo thùng HW thành công.</span> :
                                                                    <span className='retry-create-box'>
                                                                            {
                                                                                (!!_.get(i, 'item.box_partner_detail.custom_error_message') ||
                                                                                    !!_.get(i, 'item.box_partner_detail.error_message')) ?
                                                                                    <Tooltip title={_.get(i, 'item.box_partner_detail.custom_error_message') || _.get(i, 'item.box_partner_detail.error_message')}>
                                                                                        <Popover
                                                                                            content={() => renderContent(i.items)}
                                                                                            onVisibleChange={() => setListBarcode([])}
                                                                                            trigger="click"
                                                                                            placement='topRight'
                                                                                            okText="Retry"
                                                                                        >
                                                                                            <RedoOutlined style={{ fontSize: '24px', color: 'red', cursor: 'pointer' }} />
                                                                                        </Popover>
                                                                                    </Tooltip> :
                                                                                    <Popover
                                                                                        content={() => renderContent(i.items)}
                                                                                        onVisibleChange={() => setListBarcode([])}
                                                                                        trigger="click"
                                                                                        placement='topRight'
                                                                                        okText="Retry"
                                                                                    >
                                                                                        <RedoOutlined style={{ fontSize: '24px', color: 'red', cursor: 'pointer' }} />
                                                                                    </Popover>
                                                                            }
                                                                    </span>
                                                            }
                                                        </td>
                                                    }
                                                </tr>
                                            )
                                        }
                                        )}
                                        <tr>
                                            <td colSpan={4}>
                                                <div className='w-100 pr-2'>
                                                    {/* {(!!batchShipId && status === 'open') &&
                                                    <button
                                                        className='btn btn-primary mt-3 ml-3 float-right'
                                                        style={{ background: '#4A80F7' }}
                                                        onClick={handleToggleModal}
                                                    >
                                                        Confirm
                                                    </button>
                                                } */}
                                                    {(!batchShipId || status === 'open') &&
                                                    <button
                                                        className='btn btn-primary mt-3 float-right'
                                                        style={{ background: '#4A80F7' }}
                                                        onClick={() => _handleAddNewBoxes()}
                                                    >
                                                        Thêm thùng ship
                                                    </button>
                                                    }
                                                    <Modal
                                                        title='Xác nhận thông tin lô ship'
                                                        visible={showModal}
                                                        onOk={() => _handleConfirmBatchShip(batchShipId)}
                                                        onCancel={handleToggleModal}
                                                    >
                                                        <label className='text-danger'>
                                                            Lô ship '{boxNumber}' sẽ được chuyển sang trạng thái confirmed!!!
                                                        </label>
                                                    </Modal>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <Modal
                                    visible={!!shipLabelPreview}
                                    onCancel={() => setShipLabelPreview('')}
                                    footer={null}
                                    width="1000px"
                                >
                                    <img
                                        src={shipLabelPreview}
                                        alt="Ship label FBA"
                                        style={{ display: 'block', margin: '0 auto', maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                                    />
                                </Modal>
                                {!!errors && status === 'open' &&
                                    errors.map(i =>
                                    (<label
                                        className={(i.type === 'error' ? 'text-danger' : 'text-warning') + ' w-100 mt-1'}
                                        style={{ whiteSpace: "pre-line" }}
                                    >
                                        <i className={i.type === 'error' ? 'icon-cancel-circle2' : 'icon-warning22'} /> {i.msg}
                                    </label>)
                                    )
                                }
                                {!!error && (status === 'open' || status === '') &&
                                    <label className='text-danger mt-3' style={{ whiteSpace: "pre-line" }}>{error}</label >
                                }
                            </div>
                        </div>
                        {
                            !!batchShipId && status === 'confirmed' && (!!adminPermission || !!ffmPermission || !!carrier && !!trackingNumber) &&
                            <div className=" mt-4">
                                <h6 className='font-weight-bold mb-2 txt-14'>THÔNG TIN SHIP</h6>
                                <div className='d-flex flex-column mb-3 align-items-start'>
                                    <label className='txt-14'>
                                        Shipping carrier
                                        <span className='text-danger'> * </span>
                                    </label>
                                    <Select
                                        className='w-50 mb-2'
                                        allowClear
                                        value={carrier || []}
                                        disabled={shippingStatus === 'delivered' || (!adminPermission && !ffmPermission)}
                                        onChange={(value) => handleChangeShipDetails('carrier', value)}
                                    >
                                        <Option value='UPS' >UPS</Option>
                                        <Option value='DHL Express' >DHL Express</Option>
                                        <Option value='DHL eCommerce' >DHL eCommerce</Option>
                                    </Select>
                                    <label className='txt-14'>
                                        Tracking number
                                        <span className='text-danger'> * </span>
                                    </label>
                                    <Input
                                        className='w-50 mb-2'
                                        allowClear
                                        value={trackingNumber || ''}
                                        disabled={shippingStatus === 'delivered' || (!adminPermission && !ffmPermission)}
                                        onChange={({ target: { value } }) => handleChangeShipDetails('tracking_number', value)}
                                    />
                                    {
                                        (!!adminPermission || !!ffmPermission) &&
                                        <>
                                            <label className='txt-14'>
                                                Phí ship lô
                                                <span className='text-danger'> * </span>
                                            </label>
                                            <Input
                                                className='w-50'
                                                type='number'
                                                allowClear
                                                value={shippingFee || ''}
                                                disabled={shippingStatus === 'delivered'}
                                                onChange={({ target: { value } }) => handleChangeShipDetails('shipping_fee', value)}
                                            />
                                        </>
                                    }
                                </div>
                                <label className='text-danger'>
                                    {!!error && status === 'confirmed' &&
                                        <label className='text-danger'>{error}</label>
                                    }</label>
                            </div>
                        }
                    </div>
                </Spin>
            </div>
        </div>
    )
}

export default BatchShipCreatePageContainer